import React, { useEffect, useState } from 'react';
import * as echarts from 'echarts/core';

export default function WorldMapLoader({ children }) {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMap = async () => {
      try {
        const worldMap = await import('../../../assets/world-geo.json');
        echarts.registerMap('world', worldMap.default);
        setMapLoaded(true);
      } catch (err) {
        setError(err);
        console.error('Failed to load world map:', err);
      }
    };

    if (!mapLoaded && !error) {
      loadMap();
    }
  }, [mapLoaded, error]);

  if (error) {
    return <div className="alert alert-danger">地图加载失败，请刷新重试</div>;
  }

  if (!mapLoaded) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">正在加载地图数据...</p>
      </div>
    );
  }

  return children;
}